module.exports = __webpack_public_path__ + "img/26220-100.5b574ff8.jpg";